import { DatePicker } from "antd";
import moment from "moment";
import React, { useState, useEffect } from "react";

export default function MaskedDatePicker({ value, onChange, placeholder = "DD/MM/AAAA", disabled = false }) {
  const [date, setDate] = useState(value || null);
  const [text, setText] = useState(value ? value.format("DD/MM/YYYY") : "");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!value) {
      setDate(null);
      setText("");
      return;
    }
    setDate(value);
    setText(value.format("DD/MM/YYYY"));
  }, [value]);

  function maskDate(value) {
    value = value.replace(/\D/g, "");
    if (value.length > 2) value = value.replace(/(\d{2})(\d)/, "$1/$2");
    if (value.length > 5) value = value.replace(/(\d{2})\/(\d{2})(\d)/, "$1/$2/$3");
    return value.slice(0, 10);
  }

  const handleInputChange = (e) => {
    const masked = maskDate(e.target.value);
    setText(masked);

    const parsed = moment(masked, "DD/MM/YYYY", true);
    if (parsed.isValid()) {
      setDate(parsed);
      onChange?.(parsed);
    }
  };

  const handleInputBlur = () => {
    const parsed = moment(text, "DD/MM/YYYY", true);
    if (parsed.isValid()) {
      setDate(parsed);
      setText(parsed.format("DD/MM/YYYY"));
      onChange?.(parsed);
    }
    setOpen(false);
  };

  const handleCalendarChange = (d) => {
    setDate(d);
    if (d) {
      setText(d.format("DD/MM/YYYY"));
      onChange?.(d);
    } else {
      setText("");
      onChange?.(null);
    }
    setOpen(false);
  };

  return (
    <DatePicker
      format="DD/MM/YYYY"
      value={date}
      open={open}
      disabled={disabled}
      onOpenChange={setOpen}
      onChange={handleCalendarChange}
      inputRender={() => <input placeholder={placeholder} value={text} onChange={handleInputChange} onFocus={() => setOpen(true)} onBlur={handleInputBlur} />}
    />
  );
}
